import React from 'react';

export interface SortOption {
  value: string;
  label: string;
}

interface SortByDropdownProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  className?: string;
  prioritySort?: boolean;
}

const options = [
  { value: "name_asc", label: "Name (A–Z)" },
  { value: "name_desc", label: "Name (Z–A)" },
  { value: "modified_at_desc", label: "Recently modified" },
  { value: "modified_at_asc", label: "Least recently modified" },
  { value: "created_at_desc", label: "Newest created" },
  { value: "created_at_asc", label: "Oldest created" },
];
const SortByDropdown: React.FC<SortByDropdownProps> = ({
  value,
  onChange,
  label = 'Sort',
  className = '',
  prioritySort = false,
}) => {
  const currentOptions = prioritySort ? [
    ...options,
    { value: "priority_asc", label: "Priority (High-Low)" },
    { value: "priority_desc", label: "Priority (Low-High)" }
  ] : options;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-xs font-medium text-light-text-tertiary dark:text-gray-500 uppercase tracking-wide">
        {label}
      </span>
      <select
        value={value}
        onChange={onChange}
        className="bg-secondary-light dark:bg-hover-dark 
             border border-light-border-default dark:border-gray-600 
             text-light-text-primary dark:text-gray-200 
             text-sm px-2 py-1 pr-7 rounded-lg 
             hover:border-primary-light dark:hover:border-primary-dark
             focus:ring-1 focus:ring-primary-light/30 dark:focus:ring-primary-dark/30 
             cursor-pointer transition-colors"
      >
        {currentOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortByDropdown;
